module.exports = __webpack_public_path__ + "static/media/setting_bg_1.bb1d979d.png";